<template>
    <div class="container">
        <div class="login-box"> 
            <v-form>
                <v-flex xs12 sm6 md3 class="login-item">
                    <img src="@/assets/logo.png" class="pb-2" width="110">
                    <v-text-field outlined autofocus label="Email" v-model="email" type="email"></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 class="login-item">
                    <v-text-field outlined ref="password" label="Password" v-model="password" type="password"@keydown.enter="login()"></v-text-field>
                </v-flex>
            </v-form>
            <v-flex xs12 sm6 md3 class="login-item mt-0">
                <v-btn block @click.prevent="login()" outlined color="dark" class="button-style">Login</v-btn>
            </v-flex>
        </div>
    </div>
</template>

<script>
// import "firebase/firestore"
export default {
    name: 'Login',
    data(){
        return {
            email: '',
            password: ''
        }
    },
    methods: {
        login(){
            firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
            .then(() => {
                return firebase.auth().signInWithEmailAndPassword(this.email, this.password);
            })
            .then(() => {
                this.$store.dispatch('login', this.email)
                this.$router.push('/clients')
            })
            .catch(function(error) {
                console.log(error)
            })
        }
    },
    created(){
        document.title = "Vaboo Admin Login"
    }
}
</script>
<style>
.login-box{
    margin: 100px auto;
    position: relative;
}
.login-item{
    margin: 0 auto;
}
</style>



